// src/pages/admin/AdminDashboard.jsx

import React, { useEffect, useState } from 'react';
import { adminAPI, jobAdPublicAPI } from '../../services/api';
import { StatCard, Spinner } from '../../components/shared/UI';
import { Users, Briefcase, Settings, TrendingUp } from 'lucide-react';
import toast from 'react-hot-toast';

export const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      adminAPI.getUsers({ limit: 1 }),
      jobAdPublicAPI.getActive(),
    ]).then(([usersRes, jobsRes]) => {
      setStats({
        totalUsers: usersRes.data.data?.total || 0,
        activeJobs: (jobsRes.data.data?.ads || []).length,
      });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><Spinner size={32} /></div>;

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h1 className="font-display font-800 text-2xl text-white">Admin Overview</h1>
        <p className="text-gray-500 text-sm mt-1">Platform health and configuration</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Total Users" value={stats?.totalUsers || '—'} icon={Users} color="text-tikhet-amber" />
        <StatCard label="Active Jobs" value={stats?.activeJobs || '—'} icon={Briefcase} color="text-tikhet-teal" />
        <StatCard label="Match Engine" value="Online" icon={TrendingUp} color="text-tikhet-sky" />
        <StatCard label="API Status" value="Healthy" icon={Settings} color="text-tikhet-rose" />
      </div>

      <div className="card p-6">
        <h2 className="font-display font-700 text-white mb-4">Quick Links</h2>
        <div className="grid sm:grid-cols-3 gap-3">
          {[
            { to: '/admin/config', icon: Settings, label: 'Matching Config', desc: 'Tune the matching engine weights' },
          ].map(({ to, icon: Icon, label, desc }) => (
            <a key={to} href={to}
              className="flex items-start gap-3 p-4 rounded-xl bg-tikhet-dark border border-tikhet-border hover:border-tikhet-amber/30 transition-all group">
              <div className="w-9 h-9 rounded-xl bg-tikhet-amber/10 flex items-center justify-center flex-shrink-0">
                <Icon size={18} className="text-tikhet-amber" />
              </div>
              <div>
                <div className="font-display font-600 text-sm text-white group-hover:text-tikhet-amber transition-colors">{label}</div>
                <div className="text-xs text-gray-500 mt-0.5">{desc}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
